import {toastr} from 'react-redux-toastr';
import {
    SIGNUP_DATA
} from '../Types';
import axios from "axios/index";
import {API_URL} from "../../config/config";

/**
 * User registration action
 * @param data
 * @param callback
 * @returns {function(*)}
 */
export function registerUser(data, callback) {
    const request = axios.post(`${API_URL}auth/signup`, data);
    return (dispatch)=> {
        request.then((data) => {
            callback(data);
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}

/**
 * User login action
 * @param data
 * @param callback
 * @returns {function(*)}
 */
export function login(data,callback){
    const request = axios.post(`${API_URL}/auth/login`, data);
    return (dispatch)=> {
        request.then((data) => {
            callback(data);
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}

/**
 * Forgot password
 * @param values
 * @param callback
 * @returns {function(*)}
 */
export function forgotPassword(data,callback){
    const request = axios.post(`${API_URL}/auth/forgot-password`, data);
    return (dispatch)=> {
        request.then((data) => {
            callback(data);
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}

/**
 * Reset password
 * @param values
 * @param callback
 * @returns {function(*)}
 */
export function resetPassword(data,callback){
    const formData = {...data, service: SERVICE_NAME};
    const request = axios.post(`${API_URL}/auth/reset/confirm/`, formData);
    return (dispatch)=> {
        request.then((data) => {
            callback(data);
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}

/**
 * Resend set password of user
 * @param data
 * @param callback
 * @returns {function(*)}
 */

export function setPassword(data, callback){
    let postData = {
        password: data.password,
        token: data.token
    }
    const request = axios.put(`${API_URL}auth/set-password/${data.user_id}`, postData);
    return (dispatch)=> {
        request.then((data) => {
            callback(data);
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}

/**
 * Resend confirmation email
 * @param data
 * @param callback
 * @returns {function(*)}
 */
export function resendConfirmationEmail(data,callback){
    const formData = {...data, service: SERVICE_NAME};
    const request = axios.put(`${API_URL}/auth/email-resend/`, formData);
    return (dispatch)=> {
        request.then((data) => {
            callback(data);
        })
        .catch(function (error) {
            callback(error.response);
        });
    }
}


/**
 * Set signup data
 * @param data
 * @returns {function(*)}
 */
export function setSignupData(data, callback) {
    return (dispatch)=> {
        dispatch({
            type    : SIGNUP_DATA,
            payload : data
        });

        callback();
    }
}



// WEBPACK FOOTER //
// ./actions/Auth/AuthActions.js